/**
 * The versions of the terms and the privacy policy a signup accepts (decision 69; part 35a, AR1): the current ones the
 * site publishes and the relay asks for. A new version is a new entry here in the same change as the site's and the
 * relay's; a test holds all three together. A stale app is told so by the relay (`terms-outdated`, SU4).
 */
import type { Versions } from './flows.ts';

/** The current version of each document. */
export const LEGAL_VERSIONS: Versions = Object.freeze({ terms: 1, privacy: 1 });
